import React, {useEffect, useState} from 'react';
import styles from './modal.module.scss';
import {NavLink} from "react-router-dom";

const COOKIE_NAME = 'cookieMessage';
const COOKIE_EXPIRATION_DAYS = 365;

function setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function getCookie(name: string): string | null {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [key, value] = cookie.trim().split('=');
        if (key === name) {
            return value;
        }
    }
    return null;
}

const CookieConsentBanner: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = getCookie(COOKIE_NAME);
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        setCookie(COOKIE_NAME, 'accepted', COOKIE_EXPIRATION_DAYS);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className={styles.banner}>
      <span className={styles.text}>
        Продолжая использовать наш сайт, вы даете{' '}
          <NavLink to="/privacy" className={styles.link}>
                            согласие
                        </NavLink>{' '}
          на обработку файлов cookie
      </span>
            <button className={styles.button} onClick={handleAccept}>
                Хорошо
            </button>
        </div>
    );
};

export default CookieConsentBanner;
